import { Button, InformationMd } from '@property.com.au/ui-kit';
import type { FunctionComponent } from 'react';

export const DisclaimerIcon: FunctionComponent<{
  title: string;
  onClick: () => void;
  className?: string;
}> = ({ title, onClick, className }) => {
  return (
    <Button
      icon={<InformationMd title={title} id={`${title} icon`} />}
      variant="naked"
      sizeVariant="small"
      hideLabel
      compact
      onClick={onClick}
      style={{ flexGrow: 0 }}
      aria-label={title}
      aria-haspopup="dialog"
      className={className}
    />
  );
};
